<template>
    <div class="table-toolbar-wrapper">
        <div class="board-view-tabs">
            <div class="tabs-container">
                <div class="left">
                    <div
                        class="tab"
                        :class="{ active: currentBoardView === 'table' }"
                        @click="changeBoardView('table')"
                    >
                        <i class="material-icons">grid_on</i>
                        {{ $t("tables.table") }}
                    </div>
                    <div
                        class="tab"
                        :class="{ active: currentBoardView === 'kanban' }"
                        @click="changeBoardView('kanban')"
                    >
                        <i class="material-icons">view_kanban</i>
                        {{ $t("tables.kanban") }}
                    </div>
                    <div
                        class="tab"
                        :class="{ active: currentBoardView === 'calendar' }"
                        @click="changeBoardView('calendar')"
                    >
                        <i class="material-icons">event</i>
                        {{ $t("tables.calendar") }}
                    </div>
                    <div
                        v-for="page in customPages"
                        :key="page._id"
                        class="tab"
                        :class="{ active: currentBoardView === page._id }"
                    >
                        <div class="tab-content" @click="changeBoardView(page._id)">
                            <i class="material-icons">dashboard</i>
                            {{ page.name }}
                        </div>
                        <a-dropdown v-if="currentBoardView === page._id">
                            <a-button class="page-actions-btn">
                                <i class="material-icons">more_vert</i>
                            </a-button>
                            <a-menu slot="overlay" class="page-actions-menu">
                                <a-menu-item @click="duplicatePage(page)">
                                    <i class="material-icons">content_copy</i>
                                    Sayfayı Çoğalt
                                </a-menu-item>
                                <a-menu-item @click="showRenamePageModal(page)">
                                    <i class="material-icons">edit</i>
                                    Sayfayı Yeniden Adlandır
                                </a-menu-item>
                                <a-menu-item @click="confirmDeletePage(page)">
                                    <i class="material-icons" style="color: #ff4d4f">delete</i>
                                    Sayfayı Sil
                                </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                    </div>
                    <a-popover placement="bottom" trigger="click">
                        <div slot="content">
                            <div class="template-list">
                                <div class="template-item" @click="onCreateNewTablePage('blank')">
                                    <i class="material-icons">insert_drive_file</i>
                                    Blank
                                </div>
                                <div class="template-item" @click="onCreateNewTablePage('chart')">
                                    <i class="material-icons">insert_chart</i>
                                    Chart
                                </div>
                                <div class="template-item" @click="onCreateNewTablePage('form')">
                                    <i class="material-icons">assignment</i>
                                    Form
                                </div>
                                <div class="template-item" @click="onCreateNewTablePage('gantt')">
                                    <i class="material-icons">view_timeline</i>
                                    Gantt
                                </div>
                            </div>
                        </div>
                        <div class="tab add-view">
                            <i class="material-icons">add</i>
                        </div>
                    </a-popover>
                </div>
                <div class="right" v-if="moduleMode && selectedModule">
                    <div class="module-title-wrapper">
                        <i class="material-icons">{{ selectedModule.icon || "extension" }}</i>
                        <h3 class="title">{{ selectedModule.displayName }}</h3>
                    </div>
                </div>

                <!--                şu an için buton işlevsiz olduğu için uı dan kaldırıldı-->
                <!--                <div class="tab add-view">-->
                <!--                    <i class="material-icons">add</i>-->
                <!--                </div>-->
            </div>
        </div>

        <div class="table-toolbar">
            <div class="left-actions">
                <a-popover
                    placement="bottomLeft"
                    trigger="click"
                    overlayClassName="view-switcher-popover zero-padding"
                    v-model="viewSwitcherVisible"
                >
                    <template slot="content">
                        <ViewSwitcher
                            :table="table"
                            @show-view="onShowView"
                            @edit-view="onEditView"
                            @create-new-view="onCreateNewView"
                        />
                    </template>
                    <SupsisButton primary>
                        {{ currentView ? currentView.name : `${$t("tables.mainTable")} - (${table.name})` }}
                        <i class="material-icons">arrow_drop_down</i>
                    </SupsisButton>
                </a-popover>
                <!-- Filter butonuna a-popover ekliyoruz -->
                <a-popover
                    placement="bottomLeft"
                    trigger="click"
                    :visible="filterVisible"
                    overlayClassName="table-filter-popover"
                >
                    <template slot="content">
                        <TableFilter
                            :fields="fields"
                            :value="filters"
                            @input="onFilterChange"
                            @close="filterVisible = false"
                        />
                    </template>
                    <SupsisButton
                        :classNames="`${filters.length > 0 ? 'active-filters' : ''}`"
                        @click="filterVisible = !filterVisible"
                    >
                        <i class="material-icons">filter_alt</i>
                        {{ $t("tables.filter") }}
                        <span v-if="filters.length > 0" class="filter-count">
                            {{ filters.length }}
                        </span>
                        <i class="material-icons clear-filters" @click.stop="clearFilters" v-if="filters.length"
                            >close</i
                        >
                    </SupsisButton>
                </a-popover>
                <SupsisButton
                    :classNames="`${hiddenFields.length > 0 ? 'active-filters' : ''}`"
                    @click="$emit('show-hide-fields')"
                    v-if="!moduleMode"
                >
                    <i class="material-icons">visibility_off</i>
                    {{ $t("tables.hideFields") }}
                    <span v-if="hiddenFields.length > 0" class="filter-count">
                        {{ hiddenFields.length }}
                    </span>
                    <i
                        class="material-icons clear-filters"
                        @click.stop="$emit('clear-hidden-fields')"
                        v-if="hiddenFields.length > 0"
                        >close</i
                    >
                </SupsisButton>
                <!-- Burada group by'ı ekliyoruz -->
                <a-popover
                    placement="bottomRight"
                    trigger="click"
                    v-model="groupPopoverVisible"
                    overlayClassName="table-group-popover"
                >
                    <template slot="content">
                        <TableGroup :fields="fields" :group-value="groupValue" @update-group="onUpdateGroup" />
                    </template>
                    <SupsisButton :classNames="`${groupValue.fieldId ? 'active-filters' : ''}`">
                        <i class="material-icons">category</i>
                        {{ $t("message.group") }}
                        <span v-if="groupValue.fieldId" class="filter-count"> 1 </span>
                    </SupsisButton>
                </a-popover>

                <a-popover
                    placement="bottomRight"
                    v-model="colorPopoverVisible"
                    trigger="click"
                    overlayClassName="table-color-popover"
                >
                    <template slot="content">
                        <TableColorFilter
                            :fields="fields"
                            :color-conditions="colorConditions"
                            @update-color-conditions="onUpdateColorConditions"
                        />
                    </template>
                    <SupsisButton :classNames="`${colorConditions.length > 0 ? 'active-filters' : ''}`">
                        <i class="material-icons">color_lens</i>
                        {{ $t("tables.conditionalColor") }}
                        <span v-if="colorConditions.length > 0" class="filter-count">
                            {{ colorConditions.length }}
                        </span>
                    </SupsisButton>
                </a-popover>
                <SupsisButton
                    @click="$feature.beforeCreateTableView(openCreateViewModal, table.totalViews)"
                    v-if="!moduleMode"
                >
                    <i class="material-icons">save</i>
                    {{ $t("tables.saveAsView") }}
                </SupsisButton>
            </div>
            <div class="right-actions">
                <!-- Pagination bileşenini ekle -->
                <div
                    class="search-bar"
                    :class="{ expanded: searchExpanded || searchQuery }"
                    @click="searchExpanded = true"
                >
                    <input
                        type="text"
                        :placeholder="$t('tables.search')"
                        @keyup.enter="onSearchEnter"
                        @focus="searchExpanded = true"
                        @blur="searchExpanded = false"
                        ref="searchInput"
                        autofocus
                    />
                    <i class="material-icons" @click.stop="searchExpanded = true">search</i>
                </div>
                <SupsisButton primary @click="openCreateRecordModal">
                    <i class="material-icons">add</i>
                    {{ $t("message.createRecord") }}
                </SupsisButton>
                <a-popover trigger="click" placement="bottomRight" v-if="!moduleMode">
                    <template slot="content">
                        <div class="action-menu">
                            <div class="action-item" @click="handleAction('runWebhookAutomation')">
                                <i class="material-icons" style="color: #1890ff">webhook</i>
                                {{ $t("tables.runWebhookAutomation") }}
                            </div>
                            <div class="action-item" @click="handleAction('importRecords')">
                                <i class="material-icons" style="color: #52c41a">upload_file</i>
                                {{ $t("tables.importRecords") }}
                            </div>
                            <div class="action-item" @click="handleAction('downloadAllRecords')">
                                <i class="material-icons" style="color: #faad14">download</i>
                                {{ $t("tables.downloadAllRecords") }}
                            </div>
                            <div
                                class="action-item"
                                :class="{ disabled: !hasSelection }"
                                @click="handleAction('downloadSelectedRecords')"
                            >
                                <i class="material-icons" style="color: #faad14">download</i>
                                {{
                                    hasSelection
                                        ? `${$t("tables.download")} ${selectedRecords.length} ${$t("message.records")}`
                                        : $t("tables.downloadSelectedRecords")
                                }}
                            </div>
                            <div
                                class="action-item"
                                :class="{ disabled: !hasSelection }"
                                @click="handleAction('editRecords')"
                            >
                                <i class="material-icons" style="color: #1890ff">edit</i>
                                {{
                                    hasSelection
                                        ? `${$t("message.edit")} ${selectedRecords.length} ${$t("message.records")}`
                                        : $t("tables.editRecords")
                                }}
                                <span class="shortcut"> <kbd>Ctrl</kbd>+<kbd>E</kbd> </span>
                            </div>
                            <div class="action-item" :class="{ disabled: !hasSelection }" @click="confirmDeleteRecords">
                                <i class="material-icons" style="color: #ff4d4f">delete</i>
                                {{
                                    hasSelection
                                        ? `${$t("message.delete")} ${selectedRecords.length} ${$t("message.records")}`
                                        : $t("tables.deleteRecords")
                                }}
                                <span class="shortcut">
                                    <kbd>Backspace</kbd>
                                </span>
                            </div>
                            <div
                                class="action-item"
                                :class="{ disabled: !hasSelection }"
                                @click="confirmDuplicateRecords"
                            >
                                <i class="material-icons" style="color: #52c41a">content_copy</i>
                                {{
                                    hasSelection
                                        ? `${$t("message.duplicate")} ${selectedRecords.length} ${$t(
                                              "message.records"
                                          )}`
                                        : $t("tables.duplicateRecords")
                                }}
                                <span class="shortcut"> <kbd>Ctrl</kbd>+<kbd>D</kbd> </span>
                            </div>
                        </div>
                    </template>
                    <SupsisButton>
                        <i class="material-icons">more_horiz</i>
                    </SupsisButton>
                </a-popover>
                <!-- CreateViewForm'u içeren Modal2 bileşeni -->
                <Modal2
                    v-if="showCreateViewModal"
                    @cancel="closeCreateViewModal"
                    :showFooter="false"
                    :title="$t('tables.saveAsView')"
                    className="create-view-modal keydown-prevent-modal"
                >
                    <CreateViewForm
                        :filters="filters"
                        :sort="sort"
                        :search="searchQuery"
                        :hiddenFields="hiddenFields"
                        :lockedFields="lockedFields"
                        @view-created="onViewCreated"
                        @cancel="closeCreateViewModal"
                        :table-id="tableId"
                        :group-value="groupValue"
                        :color-conditions="colorConditions"
                    />
                </Modal2>
            </div>

            <Modal2
                v-if="showCreateRecordModal"
                @cancel="closeCreateRecordModal"
                :showFooter="false"
                title="Yeni Kayıt Oluştur"
                className="create-record-modal keydown-prevent-modal"
            >
                <TableCreateRecordForm
                    :table="table"
                    @record-created="onRecordCreated"
                    :predefinedValues="predefinedValues"
                    :default-linked-record-cache="defaultLinkedRecordCache"
                />
            </Modal2>
        </div>

        <!-- Yeni sayfa oluşturma modalı -->
        <Modal2
            v-if="showCreatePageModal"
            title="Yeni Sayfa Oluştur"
            @cancel="closeCreatePageModal"
            @ok="handleCreatePage"
            :okText="'Oluştur'"
            :cancelText="'İptal'"
            :showFooter="true"
        >
            <a-form :form="createPageForm" layout="vertical">
                <a-form-item label="Sayfa Adı">
                    <a-input
                        v-decorator="[
                            'name',
                            {
                                rules: [{ required: true, message: 'Lütfen sayfa adı girin' }],
                            },
                        ]"
                        placeholder="Sayfa adı girin"
                    />
                </a-form-item>
                <a-form-item label="Açıklama">
                    <a-textarea v-decorator="['description']" :rows="4" placeholder="Sayfa açıklaması girin" />
                </a-form-item>
            </a-form>
        </Modal2>

        <!-- Rename Page Modal -->
        <Modal2
            v-if="showRenameModal"
            title="Sayfayı Yeniden Adlandır"
            @cancel="closeRenameModal"
            @ok="handleRename"
            :confirmLoading="renamingPage"
            :okText="'Kaydet'"
            :cancelText="'İptal'"
        >
            <a-form-item label="Sayfa Adı">
                <a-input v-model="newPageName" placeholder="Sayfa adı girin" />
            </a-form-item>
        </Modal2>
    </div>
</template>

<script>
import Vue from "vue";
import TableGroup from "./components/TableGroup.vue";
import SupsisButton from "@/views/Pages/Settings/components/SupsisButton.vue";
import TableFilter from "./components/filter/TableFilter.vue";
import { Popover } from "ant-design-vue";
import { TABLE_API } from "../../../../api/table";
import Modal2 from "../../../../components/common/Modal2.vue";
import CreateViewForm from "./components/CreateViewForm.vue";
import ViewSwitcher from "./components/ViewSwitcher.vue";
import TableCreateRecordForm from "./RecordCreator.vue";
import TableColorFilter from "./components/filter/TableColorFilter.vue";

export default Vue.extend({
    name: "TableToolbar",
    components: {
        ViewSwitcher,
        SupsisButton,
        TableFilter,
        "a-popover": Popover,
        Modal2,
        CreateViewForm,
        TableCreateRecordForm,
        TableGroup,
        TableColorFilter,
    },
    props: {
        fields: {
            type: Array,
            required: true,
        },
        filters: {
            type: Array,
            default: function () {
                return [];
            },
        },
        selectedRecords: {
            type: Array,
            default: function () {
                return [];
            },
        },
        tableId: {
            type: String,
            required: true,
        },
        hiddenFields: {
            type: Array,
            default: function () {
                return [];
            },
        },
        lockedFields: {
            type: Array,
            default: function () {
                return [];
            },
        },
        sort: {
            type: Object,
            default: function () {
                return {};
            },
        },
        table: {
            type: Object,
            required: true,
        },
        currentView: {
            type: Object,
            default: null,
        },
        total: {
            type: Number,
            default: 0,
        },
        cursor: {
            type: Object,
            default: function () {
                return {
                    page: 1,
                    perPage: 1000,
                };
            },
        },
        moduleMode: {
            type: Boolean,
            default: false,
        },
        predefinedValues: {
            type: Object,
            default: function () {
                return {};
            },
        },
        defaultLinkedRecordCache: {
            type: Object,
        },
        groupValue: {
            type: Object,
            default: function () {
                return {
                    fieldId: null,
                    direction: "asc",
                    showEmptyGroups: false,
                };
            },
        },
        currentBoardView: {
            type: String,
            default: "table",
        },
        colorConditions: {
            type: Array,
            default: function () {
                return [];
            },
        },
        searchQuery: {
            type: String,
        },
        selectedModule: {
            type: Object,
            default: null,
        },
        customPages: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        hasSelection() {
            return this.selectedRecords.length > 0;
        },
    },
    data() {
        return {
            filterVisible: false,
            showCreateViewModal: false,
            viewSwitcherVisible: false,
            showCreateRecordModal: false,
            groupPopoverVisible: false,
            colorPopoverVisible: false,
            searchExpanded: false,
            customViews: [],
            showCreatePageModal: false,
            createPageForm: this.$form.createForm(this),
            isCreatingPage: false,
            selectedTemplateType: null,
            showRenameModal: false,
            newPageName: "",
            renamingPage: false,
            selectedPage: null,
        };
    },
    methods: {
        onFilterChange(filters) {
            this.$emit("filter-updated", filters);
        },
        clearFilters() {
            this.$emit("filter-updated", []);
        },
        onSearchEnter(event) {
            this.$emit("search", event.target.value);
        },
        handleAction(action) {
            switch (action) {
                case "editRecords":
                    if (this.hasSelection) {
                        this.$emit("edit-records");
                    }
                    break;
                case "importRecords":
                    this.importRecords();
                    break;
                case "downloadSelectedRecords":
                    if (this.hasSelection) {
                        this.$emit("download-selected-records");
                    }
                    break;
                case "downloadAllRecords":
                    this.$emit("download-all-records");
                    break;
                case "editRecords":
                    if (this.hasSelection) {
                        this.$emit("edit-records");
                    }
                    break;
                // Diğer aksiyonlar...
            }
        },
        confirmDeleteRecords() {
            if (!this.hasSelection) return;
            this.$confirm({
                title: this.$t("tables.deleteRecords"),
                content:
                    this.$t("tables.selected") +
                    " " +
                    this.selectedRecords.length +
                    " " +
                    this.$t("tables.sureDeleteRecords"),
                okText: this.$t("message.yes"),
                okType: "danger",
                cancelText: this.$t("message.no"),
                onOk: () => {
                    this.deleteSelectedRecords();
                },
            });
        },
        async deleteSelectedRecords() {
            try {
                await TABLE_API.deleteRecordsByIds(this.tableId, this.selectedRecords);
                this.$emit("records-deleted", this.selectedRecords);
                this.$message.success(this.$t("tables.selectedRecordSucs"));
            } catch (error) {
                console.error("Kayıtlar silinirken bir hata oluştu:", error);
                this.$message.error(this.$t("tables.errorDeletingRecords"));
            }
        },
        confirmDuplicateRecords() {
            if (!this.hasSelection) return;
            this.$confirm({
                title: this.$t("tables.copyRecords"),
                content:
                    this.$t("tables.selected") +
                    " " +
                    this.selectedRecords.length +
                    " " +
                    this.$t("tables.sureCopyRecords"),
                okText: this.$t("message.yes"),
                okType: "primary",
                cancelText: this.$t("message.no"),
                onOk: () => {
                    this.duplicateSelectedRecords();
                },
            });
        },
        async duplicateSelectedRecords() {
            try {
                await TABLE_API.duplicateRecords(this.tableId, this.selectedRecords);
                this.$emit("records-duplicated", this.selectedRecords);
                this.$message.success(this.$t("tables.recordsCopiedSucs"));
            } catch (error) {
                console.error("Kayıtlar kopyalanırken bir hata oluştu:", error);
                this.$message.error(this.$t("tables.recordsCopiedError"));
            }
        },
        handleKeyDown(event) {
            if (!this.hasSelection) return;

            if ((event.ctrlKey || event.metaKey) && event.key === "Backspace") {
                event.preventDefault();
                this.confirmDeleteRecords();
            } else if ((event.ctrlKey || event.metaKey) && event.key === "d") {
                event.preventDefault();
                this.confirmDuplicateRecords();
            } else if ((event.ctrlKey || event.metaKey) && event.key === "e") {
                event.preventDefault();
                this.handleAction("editRecords");
            }
        },
        openCreateViewModal() {
            this.showCreateViewModal = true;
        },
        closeCreateViewModal() {
            this.showCreateViewModal = false;
        },
        onViewCreated(newView) {
            this.$emit("view-created", newView);
            this.closeCreateViewModal();
            this.$message.success(this.$t("tables.viewSucsCreated"));
        },
        onShowView(view) {
            this.viewSwitcherVisible = false;
            this.$emit("show-view", view);
        },
        onEditView(view) {
            this.viewSwitcherVisible = false;
            this.$emit("edit-view", view);
        },
        onCreateNewView() {
            this.viewSwitcherVisible = false;
            this.$feature.beforeCreateTableView(() => {
                this.showCreateViewModal = true;
            }, this.table.totalViews);
            this.$emit("create-new-view", template);
        },
        onCreateNewTablePage(templateType) {
            this.selectedTemplateType = templateType;
            this.showCreatePageModal = true;
        },
        closeCreatePageModal() {
            this.showCreatePageModal = false;
            this.createPageForm.resetFields();
            this.selectedTemplateType = null;
        },
        async handleCreatePage() {
            try {
                const values = await new Promise((resolve, reject) => {
                    this.createPageForm.validateFields((err, values) => {
                        if (err) {
                            reject(err);
                        } else {
                            resolve(values);
                        }
                    });
                });

                this.isCreatingPage = true;

                const newPage = await TABLE_API.createTablePage(
                    this.table._id,
                    values.name,
                    values.description,
                    this.selectedTemplateType
                );

                this.$message.success("Sayfa başarıyla oluşturuldu");
                this.closeCreatePageModal();

                // Parent component'e yeni sayfanın oluşturulduğunu bildir
                this.$emit("page-created", newPage);

                // Yeni oluşturulan sayfaya geç
                this.changeBoardView(newPage._id);
            } catch (error) {
                if (error.isFieldsError) {
                    return;
                }
                console.error("Sayfa oluşturulurken hata:", error);
                this.$message.error("Sayfa oluşturulurken bir hata oluştu");
            } finally {
                this.isCreatingPage = false;
            }
        },
        importRecords() {
            this.$emit("open-import-modal");
        },
        openCreateRecordModal() {
            this.showCreateRecordModal = true;
        },
        closeCreateRecordModal() {
            this.showCreateRecordModal = false;
        },
        onRecordCreated(newRecord) {
            this.$emit("record-created", newRecord);
            this.closeCreateRecordModal();
        },
        onPageChange(page) {
            this.$emit("change-cursor", Object.assign({}, this.cursor, { page: page }));
        },
        onUpdateGroup(newGroup) {
            this.groupPopoverVisible = false;
            this.$emit("group-changed", newGroup);
        },
        changeBoardView(view) {
            if (view === "table" || view === "kanban" || view === "calendar") {
                // Temel görünümlerde pageId'yi URL'den kaldır
                const query = { ...this.$route.query };
                delete query.pageId;
                this.$router.replace({ query });
            } else {
                // Özel sayfa görünümlerinde pageId'yi URL'ye ekle
                this.$router.replace({
                    query: {
                        ...this.$route.query,
                        pageId: view,
                    },
                });
            }
            this.$emit("board-view-changed", view);
        },
        onUpdateColorConditions(newColorConditions) {
            console.log("[conditioning color] onUpdateColorConditions TableToolbar", newColorConditions);
            this.$emit("update-color-conditions", newColorConditions);
        },
        async duplicatePage(page) {
            try {
                const duplicatedPage = await TABLE_API.duplicatePage(this.table._id, page._id);
                this.$emit("page-created", duplicatedPage);
                this.$message.success("Sayfa başarıyla çoğaltıldı");
                this.changeBoardView(duplicatedPage._id);
            } catch (error) {
                console.error("Sayfa çoğaltılırken hata oluştu:", error);
                this.$message.error("Sayfa çoğaltılırken bir hata oluştu");
            }
        },
        showRenamePageModal(page) {
            this.selectedPage = page;
            this.newPageName = page.name;
            this.showRenameModal = true;
        },
        async handleRename() {
            if (!this.newPageName.trim()) {
                this.$message.warning("Lütfen sayfa adı girin");
                return;
            }

            try {
                this.renamingPage = true;
                await TABLE_API.updateTablePage(this.table._id, this.selectedPage._id, {
                    name: this.newPageName,
                });

                // Emit event to update the page in parent component
                this.$emit("page-updated", {
                    ...this.selectedPage,
                    name: this.newPageName,
                });

                this.$message.success("Sayfa adı başarıyla güncellendi");
                this.closeRenameModal();
            } catch (error) {
                console.error("Sayfa adı güncellenirken hata oluştu:", error);
                this.$message.error("Sayfa adı güncellenirken bir hata oluştu");
            } finally {
                this.renamingPage = false;
            }
        },
        closeRenameModal() {
            this.showRenameModal = false;
        },
        confirmDeletePage(page) {
            const tableId = this.table._id;
            const self = this;
            this.$confirm({
                title: "Sayfayı Sil",
                content: "Bu sayfayı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
                okText: "Evet",
                okType: "danger",
                cancelText: "Hayır",
                async onOk() {
                    try {
                        await TABLE_API.deleteTablePage(tableId, page._id);
                        self.$emit("page-deleted", page._id);
                        self.$message.success("Sayfa başarıyla silindi");
                        self.changeBoardView("table");
                    } catch (error) {
                        console.error("Sayfa silinirken hata oluştu:", error);
                        self.$message.error("Sayfa silinirken bir hata oluştu");
                    }
                },
            });
        },
    },
    created() {},
    mounted() {
        document.addEventListener("keydown", this.handleKeyDown);
    },
    beforeDestroy() {
        document.removeEventListener("keydown", this.handleKeyDown);
    },
});
</script>

<style scoped lang="scss">
.table-toolbar-wrapper {
    background-color: #f5f5f5;
}

.board-view-tabs {
    border-bottom: 1px solid #e8e8e8;

    .tabs-container {
        display: flex;
        justify-content: space-between;
        .left {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 4px;
        }
        .right {
            .module-title-wrapper {
                display: flex;
                align-items: center;
                gap: 10px;
                padding: 10px;
                h3 {
                    margin: 0;
                }
            }
        }
    }

    .tab {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 8px 16px;
        cursor: pointer;
        border-radius: 4px 4px 0 0;
        margin-bottom: -1px;

        .tab-content {
            display: flex;
            align-items: center;
            gap: 6px;
        }

        .page-actions-btn {
            padding: 0 4px;
            border: none;
            background: transparent;
            margin-left: 8px;
            height: fit-content !important;

            &:hover {
                background-color: rgba(0, 0, 0, 0.04);
            }

            .material-icons {
                font-size: 18px;
            }
        }

        &:hover {
            background-color: #e6e6e6;
        }

        &.active {
            background-color: white;
            border: 1px solid #e8e8e8;
            border-bottom-color: white;
        }

        &.add-view {
            padding: 8px;
            margin-left: 8px;

            .material-icons {
                font-size: 20px;
            }
        }

        i {
            font-size: 18px;
        }
    }
}

.table-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    background-color: #f5f5f5;
    border-bottom: 1px solid #e8e8e8;
}

.left-actions {
    display: flex;
    gap: 10px;
}

.right-actions {
    display: flex;
    align-items: center;
    gap: 10px;

    :deep(.ant-pagination) {
        margin-left: 10px;
    }
}

.btn {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;

    &.btn-primary {
        background-color: #007bff;
        color: #fff;
    }

    &.btn-secondary {
        background-color: #fff;
        color: #333;
        border: 1px solid #ccc;
    }

    .material-icons {
        margin-right: 5px;
    }

    &.dropdown-toggle::after {
        content: "\e5c5";
        font-family: "Material Icons";
        vertical-align: middle;
        margin-left: 5px;
    }
}

.search-bar {
    position: relative;
    transition: width 0.3s ease;

    &.expanded {
        width: 200px;
        input {
            opacity: 1;
        }
    }

    input {
        padding: 8px 12px;
        border: 1px solid #ccc;
        border-radius: 4px;
        font-size: 14px;
        width: 100%;
        opacity: 0;
        transition: opacity 0.3s ease;

        .expanded & {
            opacity: 1;
        }
    }

    .material-icons {
        position: absolute;
        top: 50%;
        right: 8px;
        transform: translateY(-50%);
        color: #999;
        cursor: pointer;
    }
}

.active-filters {
    background-color: #fe6244 !important;
    color: white;
}

.filter-count {
    margin-left: 4px;
    background-color: rgba(0, 0, 0, 0.2);
    padding: 2px 4px;
    border-radius: 4px;
    font-size: 12px;
    display: inline-flex;
    align-items: center;

    .clear-filters {
        font-size: 14px;
        margin-left: 2px;
        cursor: pointer;
    }
}

.action-menu {
    display: flex;
    flex-direction: column;

    .action-item {
        display: flex;
        align-items: center;
        padding: 8px 12px;
        cursor: pointer;

        &:hover {
            background-color: #f0f0f0;
        }

        &.disabled {
            cursor: not-allowed;
            color: #ccc;

            .material-icons {
                color: #ccc !important;
            }
        }

        .material-icons {
            margin-right: 8px;
        }

        .shortcut {
            margin-left: 8px;
            color: #999;
            font-size: 12px;

            kbd {
                display: inline-block;
                padding: 2px 4px;
                font-size: 11px;
                line-height: 1;
                color: #666;
                background-color: #f7f7f7;
                border: solid 1px #ccc;
                border-bottom-color: #bbb;
                border-radius: 3px;
                box-shadow: inset 0 -1px 0 #bbb;
            }
        }
    }
}

.table-color-popover {
    max-width: 300px;
}

.template-list {
    display: flex;
    flex-direction: column;

    .template-item {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px 16px;
        cursor: pointer;
        transition: background-color 0.3s;

        &:hover {
            background-color: #f5f5f5;
        }

        .material-icons {
            font-size: 20px;
        }
    }
}

:deep(.ant-dropdown-menu-item) {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;

    .material-icons {
        font-size: 18px;
    }
}
</style>
<style lang="scss">
.supsis-button {
    &.active-filters {
        background-color: #1890ff;
        color: white;
    }
}
.page-actions-menu {
    .ant-dropdown-menu-item {
        display: flex;
        align-items: center;
        gap: 8px;
    }
}
</style>
